/**
 * 預載入狀態
 * 載入遊戲所需的所有資源（圖片、音效、動畫等）
 */
export default class Preload {

  /**
   * 初始化預載入狀態
   */
  constructor() {
    this.asset = null;
    this.ready = false;
  }

  /**
   * 預載入階段
   * 此階段在 create() 中實際執行載入
   */
  preload() {
    // 預載入階段可以在此添加額外的初始化邏輯
  }

  /**
   * 創建階段
   * 設置進度條並開始載入所有遊戲資源
   */
  create() {
    this.load.onFileError.add((key, file) => {
      console.error('[LOAD ERROR]', key, file && file.url);
    });

    // 設置進度條精靈
    this.asset = this.add.sprite(this.game.width / 2, this.game.height / 2, 'preloader');
    this.asset.anchor.setTo(0.5, 0.5);

    // 設置載入完成回調
    this.load.onLoadComplete.addOnce(this.onLoadComplete, this);
    this.load.setPreloadSprite(this.asset);

    // 載入所有遊戲資源
    this.loadGameAssets();

    // 開始載入
    this.load.start();
  }

  /**
   * 載入所有遊戲資源
   * 包括圖片、精靈表、音效等
   */
  loadGameAssets() {
    // 輔助函數：確保 URL 是字串格式
    const ensureString = (url) => {
      if (typeof url === 'string') {
        return url;
      }
      // 如果是 webpack 模塊對象，嘗試獲取 default 或直接轉換
      if (url && typeof url === 'object') {
        return url.default || url.toString();
      }
      // 如果仍然不是字串，轉換為字串
      return String(url || '');
    };

    // 載入UI圖片
    this.load.image('circle', ensureString(require('../assets/images/circle.png')));
    this.load.image('sign', ensureString(require('../assets/images/infoSign.png')));

    // 載入背景
    this.load.image('cloud_bg', ensureString(require('../assets/images/cloud_bg.jpg')));
    this.load.image('office_02', ensureString(require('../assets/images/office_01.jpg')));

    // 載入蟑螂精靈表（不同顏色）
    const cockroachFrameSize = { width: 200, height: 300 };
    this.load.spritesheet('cockroach', ensureString(require('../assets/images/cockroach-topview-Sprites.png')), cockroachFrameSize.width, cockroachFrameSize.height);
    this.load.spritesheet('cockroach-green', ensureString(require('../assets/images/cockroach-topview-green.png')), cockroachFrameSize.width, cockroachFrameSize.height);
    this.load.spritesheet('cockroach-lbrown', ensureString(require('../assets/images/cockroach-topview-Lbrown.png')), cockroachFrameSize.width, cockroachFrameSize.height);
    this.load.spritesheet('cockroach-purple', ensureString(require('../assets/images/cockroach-topview-purple.png')), cockroachFrameSize.width, cockroachFrameSize.height);
    this.load.spritesheet('cockroach-red', ensureString(require('../assets/images/cockroach-topview-red.png')), cockroachFrameSize.width, cockroachFrameSize.height);
    this.load.image('cockroach-die', ensureString(require('../assets/images/cock-die-300.png')));

    // 載入蜘蛛精靈表
    this.load.spritesheet('spider', ensureString(require('../assets/images/spider_giant_transparent.png')), 1536 / 32, 384 / 8, 256, 0, 0);

    // 載入角色精靈表
    this.load.spritesheet('dude', ensureString(require('../assets/images/pGGbv.png')), 1142 / 12, 635 / 4);

    // 載入外部煙霧圖片（跨域）
    this.load.crossOrigin = 'anonymous';
    this.load.image('smoke', 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/101507/mist1.png');

    // 載入音效
    this.loadAudioFiles();
  }

  /**
   * 載入所有音效檔案
   */
  loadAudioFiles() {
    // 根據構建環境動態設置音頻路徑前綴
    // 開發模式: /sounds, 生產模式: /game/1787/sounds
    const soundsBasePath = process.env.NODE_ENV === 'production' 
      ? '/game/1787/sounds' 
      : '/sounds';
    
    // 調試：輸出當前環境和路徑
    console.log('Audio loading - NODE_ENV:', process.env.NODE_ENV);
    console.log('Audio loading - soundsBasePath:', soundsBasePath);
    
    this.game.load.audio('On_the_Bach', [`${soundsBasePath}/On_the_Bach.mp3`]);
    this.game.load.audio('woman-scream-01', [`${soundsBasePath}/woman-scream-01.mp3`]);
    this.game.load.audio('woman-scream-02', [`${soundsBasePath}/woman-scream-02.mp3`]);
    this.game.load.audio('man-scream-01', [`${soundsBasePath}/man-scream-01.mp3`]);
    this.game.load.audio('man-scream-02', [`${soundsBasePath}/man-scream-02.mp3`]);
    this.game.load.audio('fart-01', [`${soundsBasePath}/fart-01.mp3`]);
    this.game.load.audio('fart-03', [`${soundsBasePath}/fart-03.mp3`]);
  }

  /**
   * 更新循環
   * 檢查資源是否載入完成，完成後直接轉換到遊戲場景
   */
  update() {
    if (this.ready) {
      this.game.state.start('game');
    }
  }

  /**
   * 載入完成回調
   * 當所有資源載入完成時被調用
   */
  onLoadComplete() {
    const img = this.game.cache.getImage('spider');
    const fd = this.game.cache.getFrameData('spider');
  
    console.log('spider image size:', img && img.width, img && img.height);
    console.log('spider total frames:', fd && fd.total);
  
    this.ready = true;
  }

}
